export default __webpack_public_path__ + "static/media/education-img-cover-clarity.47460bff.png";